import React from "react";

const TermsOfUse = () => {
  return (
    <div className="px-6 py-10 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-8 text-blue-700">Terms of Use</h1>

      {/* AGREEMENT TO TERMS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Agreement to Terms</h2>
        <p className="mb-3 leading-relaxed">
          These Terms of Use constitute a legally binding agreement made between
          you, whether personally or on behalf of an entity (“you”) and SHREE
          GAJANANA ENTERPRISES LLP, doing business as Study Tap ("Study Tap",
          “we”, “us”, or “our”), concerning your access to and use of the
          StudyTap website and related media, applications, or services
          (collectively, the “Site”). We are registered in India with our
          registered office at 8/2/289/7, Banjara Hills, Hyderabad, Telangana
          507003.
        </p>

        <p className="mb-3 leading-relaxed">
          By accessing the Site, you agree that you have read, understood, and
          agree to be bound by all of these Terms of Use, including the User
          Agreement posted on the Site. IF YOU DO NOT AGREE WITH ALL OF THESE
          TERMS OF USE, THEN YOU ARE PROHIBITED FROM USING THE SITE AND MUST
          DISCONTINUE USE IMMEDIATELY.
        </p>

        <p className="mb-3 leading-relaxed">
          Supplemental terms or documents posted on the Site from time to time
          are incorporated herein by reference. We may modify these Terms of Use
          at any time, and will update the “Last Updated” date accordingly. By
          continuing to use the Site after changes are posted, you accept the
          revised Terms.
        </p>

        <p className="mb-3 leading-relaxed">
          The Site is not intended for use in any jurisdiction where such use is
          illegal or would subject us to additional legal requirements. Users
          accessing the Site from other countries do so at their own risk and
          are responsible for compliance with local laws.
        </p>

        <p className="mb-3 leading-relaxed">
          All users who are minors (generally under 18) must have permission
          from a parent or guardian to use the Site.
        </p>

        <p className="leading-relaxed">
          Kindly note that StudyTap provides study materials to assist learning.
          You are responsible for your own study performance.
        </p>
      </section>

      {/* INTELLECTUAL PROPERTY RIGHTS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">
          Intellectual Property Rights
        </h2>
        <p className="mb-3 leading-relaxed">
          Unless otherwise stated, the Site and all content—including source
          code, databases, designs, software, media, text, photographs, graphics
          (“Content”), and trademarks or logos (“Marks”)—are owned or licensed
          by us and protected by law.
        </p>
        <p className="mb-3 leading-relaxed">
          The Content and Marks are provided “AS IS” for your personal,
          non-commercial use only. No part of the Site may be copied,
          reproduced, distributed, sold, or exploited for commercial purposes
          without our permission.
        </p>
        <p className="leading-relaxed">
          If eligible, we grant you a limited license to access the Site and
          download or print portions of the Content for personal use only.
        </p>
      </section>

      {/* USER REPRESENTATIONS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">User Representations</h2>
        <p className="leading-relaxed mb-3">By using the Site, you represent that:</p>
        <ul className="list-disc ml-6 space-y-2 leading-relaxed">
          <li>Your registration information is accurate and complete.</li>
          <li>You will maintain updated account information.</li>
          <li>You have legal capacity to agree to these Terms.</li>
          <li>You are not a minor, or you have parental permission.</li>
          <li>You will not use bots or automated tools to access the Site.</li>
          <li>You will not use the Site for illegal activities.</li>
          <li>You will comply with applicable laws and regulations.</li>
          <li>
            StudyTap only provides study material; you are responsible for your
            own academic performance.
          </li>
        </ul>

        <p className="mt-3 leading-relaxed">
          If information is inaccurate or incomplete, we may terminate your
          account. Information may be shared with educational institutions for
          career guidance.
        </p>
      </section>

      {/* USER REGISTRATION */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">User Registration</h2>
        <p className="leading-relaxed">
          You may be required to register. You must maintain confidentiality of
          your password. We may modify or remove usernames that we deem
          inappropriate.
        </p>
      </section>

      {/* FEES PAYMENT */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Fees and Payment</h2>
        <p className="mb-3 leading-relaxed">We accept the following payment methods:</p>
        <ul className="list-disc ml-6 space-y-1 leading-relaxed">
          <li>Visa</li>
          <li>Mastercard</li>
          <li>Net Banking</li>
          <li>UPI</li>
          <li>PayPal</li>
          <li>Discover</li>
          <li>American Express</li>
        </ul>

        <p className="mt-3 leading-relaxed">
          You authorize us to charge your selected payment method. All payments
          are in INR and non-refundable. Cancellations apply after the current
          billing cycle.
        </p>

        <p className="mt-3 leading-relaxed">
          For support, email <strong>studytap21@gmail.com</strong> or call{" "}
          <strong>+91 6304-702631</strong>.
        </p>
        <p className="leading-relaxed">
          Account deletion must be requested directly for privacy reasons.
        </p>
      </section>

      {/* SOFTWARE */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Software</h2>
        <p className="leading-relaxed">
          Software provided via the Site may include an EULA. All software is
          provided “as is” with no warranties.
        </p>
      </section>

      {/* PROHIBITED ACTIVITIES */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Prohibited Activities</h2>
        <p className="leading-relaxed mb-3">
          You may NOT use the Site in unlawful ways. Prohibited actions include:
        </p>
        <ul className="list-disc ml-6 space-y-2 leading-relaxed">
          <li>Scraping or harvesting data.</li>
          <li>Impersonation.</li>
          <li>Uploading malware.</li>
          <li>Disrupting operations.</li>
          <li>Reverse engineering.</li>
          <li>Using bots or automated tools.</li>
          <li>Harassing StudyTap staff.</li>
          <li>Selling or transferring profile.</li>
          <li>Violating intellectual property laws.</li>
          <li>Posting harmful content.</li>
        </ul>
      </section>

      {/* USER CONTRIBUTIONS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">
          User-Generated Contributions
        </h2>
        <p className="leading-relaxed">
          If you submit content, you must ensure it complies with laws and these
          Terms.
        </p>
      </section>

      {/* CONTRIBUTION LICENSE */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Contribution License</h2>
        <p className="leading-relaxed">
          By submitting feedback or content, you grant us rights to use it for
          lawful purposes without compensation.
        </p>
      </section>

      {/* REVIEWS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Guidelines for Reviews</h2>
        <p className="leading-relaxed mb-3">Reviews must:</p>
        <ul className="list-disc ml-6 space-y-2 leading-relaxed">
          <li>Be based on firsthand experience</li>
          <li>Not contain offensive language</li>
          <li>Not reference illegal activity</li>
          <li>Not be false or misleading</li>
          <li>Not belong to review manipulation campaigns</li>
        </ul>
      </section>

      {/* MOBILE LICENSE */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">
          Mobile Application License
        </h2>
        <p className="leading-relaxed mb-3">
          You may install and use the app according to App Store or Google Play
          rules.
        </p>
        <p className="mb-3">Restrictions include:</p>
        <ul className="list-disc ml-6 space-y-2 leading-relaxed">
          <li>No reverse engineering</li>
          <li>No redistribution or modification</li>
          <li>No commercial misuse</li>
          <li>No violation of laws</li>
        </ul>
      </section>

      {/* SUBMISSIONS */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">Submissions</h2>
        <p className="leading-relaxed">
          Any ideas or feedback you submit become our property without
          compensation.
        </p>
      </section>

      {/* THIRD PARTY */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-3">
          Third-Party Websites and Content
        </h2>
        <p className="leading-relaxed">
          We are not responsible for external websites or content you access
          through the Site.
        </p>
      </section>

      {/* SITE MANAGEMENT */}
      <section className="mb-16">
        <h2 className="text-2xl font-semibold mb-3">Site Management</h2>
        <p className="leading-relaxed">
          We reserve the right to monitor, restrict, or remove content, manage
          user behavior, or limit access to maintain Site integrity.
        </p>
      </section>
    </div>
  );
};

export default TermsOfUse;
